import './landing.style.sass';
import template from './landing.tpl.pug';

class LandingController {
    /* @ngInject */
    constructor($state, $window, planService, configuration) {
        this.$state = $state;
        this.$window = $window;
        this.planService = planService;
        this.configuration = configuration;
    }

    $onInit() {
        this.loadingPlans = true;

        this.planService.getAll().then((plans) => {
            this.plans = plans;
        }).finally(() => {
            this.loadingPlans = false;
        });

        this.appDownloadUrl = this.configuration.appDownloadUrl;
        this.iosDownloadUrl = this.configuration.iosDownloadUrl;
        this.androidDownloadUrl = this.configuration.androidDownloadUrl;
        this.isMobile = !!this.getMobileOperatingSystem();

        this.testimonials = [
            {
                content: `Excellent This is exactly what I have been looking for! I don't need all of the fancy finance stuff, just a simple way to see what will be in my account each day based on pre-planned bills/expenses. 😃`,
                author: `Ariel G.`
            },
            {
                content: `This app changed my life. Works great, intuitive, doesn't link to your bank account, just easy way to record all your purchases. I love the clean simple design. I've used it nonstop since I downloaded it!!`,
                author: `Emily Pratt B.`
            },
            {
                content: `Every other financial app I've ever tried didn't work for me because they are designed for people who make 1 or 2 paychecks a month and don't use a lot of cash. As a hairstylist I have various incomes coming in at all different times and bills coming out at all times of the month. This app lets helps me keep it all together! If you're looking for a budget app that is designed for real life, I highly recommend you give this one a try!`,
                author: `Whitemistfalls`
            },
            {
                content: `Life Changing I bet other apps can do this too, but Dollarbird happens to be the one that changed my life. In a matter of days I could turn the reminders off, I automatically take out Dollarbird when I spend and especially when I earn now. The detailed feedback on my account makes me save and work alot harder for what's mine.`,
                author: `Thijs v. d. H.`
            },
            {
                content: `Great app for tracking spending The app is very efficiently laid out, making it easy to add all transactions quickly.  It's very helpful being able to see a breakdown of your spending over time and to see where all your money goes. I use it daily and it has helped me save and account for all my spending.`,
                author: `Josh T.`
            },
            {
                content: `I love this app. It's simple yet robust. I like that I do not have to link all of my accounts to track spending. I can input recurring expenses, easily adjust them, and I can budget. I like the future income and expense forecast feature. I've downloaded literally 25 different apps over the years and I continue to use this one with no complaints.`,
                author: `Allene S.`
            },
            {
                content: `Been using @dollarbirdapp for tracking expenses while traveling, and loving every bit of it. simplicity rules! going Pro from April.`,
                author: `Exotic Gringo`
            },
            {
                content: `Never been as comfortable tracking expenses as i am with @dollarbirdapp. don't let yourself be fooled by the name. universal app, great ux`,
                author: `Igor S.`
            }
        ];
    }

    select(plan, subscription) {
        if (plan && plan.id) {
            if (subscription) {
                if (subscription.id) {
                    return this.$state.go('payment', {
                        plan: plan.id,
                        subscription: subscription ? subscription.id : null
                    });
                }

                return this.$state.go('sign-up');
            }

            return this.$window.open(`mailto:${this.configuration.salesEmail}`, '_self');
        }
    }

    getMobileOperatingSystem() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return 'iOS';
        }

        return null;
    }
}

export default {
    selector: 'dbPLanding',
    template: template(),
    controller: LandingController
};



// WEBPACK FOOTER //
// ./src/presentation/scene/landing/landing.cmpt.js